import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { InProductTrialsAppController } from '../controller/InProductTrialsAppController';
import { AvailableProductTrialType } from '../../types/AvailableProductTrialType';

export class InProductTrialsAppWebComponent extends BaseWebComponentElement {
  public controller!: InProductTrialsAppController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: InProductTrialsAppController,
    });
  }

  /**
   * Show the landing page for the given trial type
   *
   * Note: This method is called from Extjs when user navigates to trial page, via url
   * See: Application.modules.inProductTrials.module.onProductRoute
   */
  public showGzLandingPageForProductTrial(trialType: AvailableProductTrialType) {
    this.controller.showGzLandingPageForProductTrial(trialType);
  }
}
